import { IPaths } from "~/types/routing";

export const paths: IPaths = {
  home: "/",
  winningAds: "/winning-ads",
  aliexpressProducts: "/aliexpress-products",
  winningProducts: "/winning-products",
  usEuProducts: "/us-eu-products",
  orders: "/orders",
  sampleOrders: "/sample-orders",
  customization: "/customization",
  importList: "/import-list",
  liveProducts: "/live-products",
  productAnalyzer: "/product-analyzer",
  brandedInvoice: "/branded-invoice",
  cancel: "/cancel",
  notFound: "/not-found",
  promoReviews: "/reviewspro",
};
